var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.75C7.0335 2.75 6.25 3.5335 6.25 4.5C6.25 5.4665 7.0335 6.25 8 6.25C8.9665 6.25 9.75 5.4665 9.75 4.5C9.75 3.5335 8.9665 2.75 8 2.75ZM4.75 4.5C4.75 2.70507 6.20507 1.25 8 1.25C9.79493 1.25 11.25 2.70507 11.25 4.5C11.25 6.29493 9.79493 7.75 8 7.75C6.20507 7.75 4.75 6.29493 4.75 4.5ZM2.23926 13.8333C2.23926 11.025 4.97221 9 8.00009 9C11.028 9 13.7609 11.025 13.7609 13.8333C13.7609 14.2475 13.4251 14.5833 13.0109 14.5833C12.5967 14.5833 12.2609 14.2475 12.2609 13.8333C12.2609 12.1267 10.5022 10.5 8.00009 10.5C5.49796 10.5 3.73926 12.1267 3.73926 13.8333C3.73926 14.2475 3.40347 14.5833 2.98926 14.5833C2.57504 14.5833 2.23926 14.2475 2.23926 13.8333Z",
    fill: "#011235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.c4820fef7fddc9e65f767ba76e09f73f.svg";
export { ForwardRef as ReactComponent };